import { render, staticRenderFns } from "./DbsDistribTask.vue?vue&type=template&id=37b2abaa&"
import script from "./DbsDistribTask.vue?vue&type=script&lang=js&"
export * from "./DbsDistribTask.vue?vue&type=script&lang=js&"
import style0 from "./DbsDistribTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports